import React from "react";

export default function FeatureImg({ ImgSource }) {
  return (
    <>
      <div id="features" className="feature-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center mb-5">
                
                <h2>The Strengths of The Sustainable Institute</h2>
                <p>
                The Sustainable Institute offers a wide range of consulting & advisory services and utilizes its strong research and strategy base to support each client's decision-making. The firm’s strategic marketing approach keeps innovation at the heart of the process, using insight into both advanced technological developments and novel business models.
                </p>
              </div>
            </div>
          </div>
          <div className="row row-grid align-items-center">
            <div className="col-lg-4">
              <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-1 rounded-circle">
                    <span className="ti-face-smile"></span>
                  </div>
                </div>
                <div className="icon-text">
                  
                  <p className="mb-0">
                  An international and interdisciplinary team fortified with highly technical backgrounds and complemented by financial, communication, political, regulatory and innovation experts
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-2 rounded-circle">
                    <span className="ti-vector"></span>
                  </div>
                </div>
                <div className="icon-text">
                  <p className="mb-0">
                  Technologically advanced solutions which lead to high-quality results
                  </p>
                </div>
              </div> <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-2 rounded-circle">
                    <span className="ti-vector"></span>
                  </div>
                </div>
                <div className="icon-text">
                  <p className="mb-0">

                  A state-of-the-art tool suite that contributes and ensures a project’s optimization                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-3 rounded-circle">
                    <span className="ti-headphone-alt"></span>
                  </div>
                </div>
                <div className="icon-text">
                 
                  <p className="mb-0">
                   
                  A multilingual firm, which facilitates optimal communication, coordination, and strategy in large projects and programs                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="position-relative" style={{ zindex: 10 }}>
                <img
                  alt="placeholder"
                  src={ImgSource}
                  className="img-center img-fluid"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-4 rounded-circle">
                    <span className="ti-layout-media-right"></span>
                  </div>
                </div>
                <div className="icon-text">
           
                  <p className="mb-0">
                  Transparency in our daily activities and subscribe to the EU Transparency Register
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-5 rounded-circle">
                    <span className="ti-layout-cta-right"></span>
                  </div>
                </div>
                <div className="icon-text">
                 
                  <p className="mb-0">
                  An extensive network of partners and experts worldwide
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-5">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-5 rounded-circle">
                    <span className="ti-layout-cta-right"></span>
                  </div>
                </div>
                <div className="icon-text">
                 
                  <p className="mb-0">
                  A single point of accountability and leadership in every project
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start">
                <div className="pr-4">
                  <div className="icon icon-shape icon-color-6 rounded-circle">
                    <span className="ti-palette"></span>
                  </div>
                </div>
                <div className="icon-text">
                
                  <p className="mb-0">
                  A team culture of initiative and responsibility that gets the job done right, on time,
and on budget                  </p>
                </div>
                
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
